import React, { useEffect, useState } from "react";
import TicketRaise from '../../../assets/ticket raise.png';
import XX from '../../../assets/XX.png';
import { useLocation } from "react-router-dom";



export default function TicketRaisedModal({
  orderReport,
  onClose,
  id,
  message,
  result,
  setTickeRaiseSuccesFlag,
  raiseTicketData,
}) {
  const [createdTime, setCreatedTime] = useState("");
    const location = useLocation();
     const params = new URLSearchParams(location.search);
  
  
  
    const isWebview = params.get("webview")
    //console.log("isWebview --",isWebview,isWebview=="true")
      const mobileNumber = params.get("mobileNumber")
  useEffect(() => {
    const now = new Date();
    const formattedDate = now.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    setCreatedTime(formattedDate);
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
  <div
  className="bg-white rounded-lg p-6 w-96 shadow-lg relative text-center"
  style={{
    position: "fixed",
    bottom: isWebview=="true"? "auto" : "0",
    width: "350px"
  }}
>

        {/* Close Button */}
        <div style={{}}>
{/* Close Button Positioned Above Modal */}
<div
  onClick={() => setTickeRaiseSuccesFlag(false)}
  style={{
    position: "absolute",
    bottom: "100%", // places it above the modal
    left: "50%",
    transform: "translateX(-50%)",
    marginBottom: "20px", // space between button and modal
    background: "white",
    height: "37px",
    width: "37px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    cursor: "pointer",
    zIndex: 10,
  }}
>
  <img src={XX} style={{ width: "11px" }} alt="Close" />
</div>


        </div>

        {/* Image */}
        <div className="flex justify-center mb-4 mt-2">
          <img src={TicketRaise} alt="Ticket Raised" style={{ width: "70%" }} />
        </div>

        {/* Heading */}
        <h2 className="text-xl font-semibold mb-2 text-gray-800">
          Your Ticket Has Been Raised
        </h2>

        {/* Ticket Info */}
        <div
          className="border border-dashed border-green-500 rounded-md p-2 mb-2 text-sm text-gray-700"
          style={{ fontSize: "12px" }}
        >
          <div className="text-green-600 font-medium">
            Ticket Id :- {orderReport?.data?.ticketId}
          </div>
          <div>Created On: {createdTime}</div>
        </div>

        <p className="text-gray-600 text-sm mb-2" style={{ fontSize: "12px" }}>
          Expected Resolution Time: <strong>Within 4 Hours</strong>
        </p>
        <hr style={{ padding: "5px" }} />
        <p className="text-gray-500 text-sm mb-4" style={{ fontSize: "12px" }}>
          A message with your ticket details has been sent to your WhatsApp also
        </p>

        {/* Open WhatsApp Button */}
        {!(isWebview=="true")&&
        <a
          href="https://wa.me/917289005034"
          className="bg-green-500 hover:bg-green-600 text-white rounded flex items-center justify-center gap-2 mx-auto"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "4px",
            paddingBottom: "4px",
            width: "30%",
          }}
        >
          Open
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            className="w-5 h-5"
            alt="WhatsApp"
          />
        </a>
}
      </div>
    </div>
  );
}
